module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAS1JREFUOBGlVD1OgkEQnRl6hdraIwAVQoKFRhNLT+CpPAGliUYLSPipkCNYW6P27DBvklmI+qEsW3w7Ozvv7X4z85bpl/Fx0ewT0y0pnSnpCUKY+N0+U/MN6i+L0XcYbzs+r9unaZXuSbW77f9hM0+kJnfHj/O32MtEX1etTkr6oKqN2Nw1M/NShG+Onl5niHMi3ERXaf5fkjgAZFyTNm4mcOJ39iUBDhhPhdmMxFpCh9goHVaIc/HqlDIEziosKHGsi2fjkOiTYhIDgsOTfQhJYMU7NlaFMziQ7GkhfgMzDiR7sPEUWsbhnb28bI7/1FfVGaa7xvOi58mGANHuVbFVftebYbHvRK4VE+A+ZE5imHgBcvmhYgiQ7KpVN8h+i0FsKB/+/IzkIDNKHrY132BwyOIRa3cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/chat-bubbles-indicator.png
// module id = 2285
// module chunks = 0